import { CustomerDbMicroservicePort, CustomerDBStatus, CustomersBySerial } from "@ip6m/types";
import { Injectable, Logger } from "@nestjs/common";
import { Client, ClientProxy, Transport } from "@nestjs/microservices";
import { Observable } from "rxjs";

@Injectable()
export class CustomerDbClient {

    @Client({
      transport: Transport.TCP,
      options: {
        port: CustomerDbMicroservicePort.default
      }
    })
    protected client: ClientProxy;

    init() {
      const cmd = { cmd: 'status' };
      const payload = '';
      return this.client.send(cmd, payload);
    }

    getCustomers(sn: string = ''): Observable<CustomersBySerial> {
      const cmd = { cmd: 'customers' };
      const payload = sn;

      return this.client.send(cmd, payload);
    }

}

@Injectable()
export class GiganetCustomerDbClient extends CustomerDbClient {

    @Client({
      transport: Transport.TCP,
      options: {
        port: CustomerDbMicroservicePort.giganet
      }
    })
    protected client: ClientProxy;

}
